module.exports = __webpack_public_path__ + "static/media/law_route.4bf5235c.png";